gsap.registerPlugin(ScrollTrigger);

mzFunc = {
	['offsetAlert']:0,
	['offsetPermAlert']:0,
	['offsetMenu']:0,
	['offsetSubmenu']:0,
	['offsetStickySubmenu']:0,
	['scrollerPosition']:0,
	['lastScrollheight']: document.body.scrollHeight,
	['firstLoad']: true,
	['loggingEnabled']: false,
	['environments']:[
		[
            '127.0.0.1',
            'dev'
        ],
        [
            'localhost',
            'dev'
		],
        [
            'dev.mazda.ca',
            'dev'
        ],		
        [
            'mzca02mstrs16bzs001.dxcloud.episerver.net',
            'staging'
        ],
        [
            'mzca03mstre4u53inte.dxcloud.episerver.net',
            'staging'
        ],		
		[
            'preprod.mazda.ca',
            'staging'
		],
		[
            'preprod2.mazda.ca',
            'staging'
        ],		
        [
            'cms.mazda.ca',
            'production'
		],
        [
            'prod.mazda.ca',
            'production'
        ],		
        [
            'www.mazda.ca',
            'production'
        ],
        [
            'mazda.ca',
            'production'
        ]
    ],
	getLang: function(){
		const docLang = document.querySelector('meta[name="data-language"]');
		const lang = docLang != null ? docLang.getAttribute('content') : 'en';
		
		return lang;
	},
	animateJellies: function(target){
		const tl = gsap.timeline();
		const jellyArr = target.querySelectorAll('.mz-tabs-container > .mz-container.active .mz-jelly');
		jellyArr.forEach((item, i) => {
			gsap.set(item,{autoAlpha:0, y:'-=20'});
		});
		jellyArr.forEach((item, i) => {
			let delayVal = i === 0 ? 0.3 : 0;
			tl.to(item, 0.4,{delay:delayVal, autoAlpha:1, y:0},'-=0.2');
		});
	},
	bakeCookie: function(cookie, recipe, expires){
		const d = new Date();
		d.setTime(d.getTime() + (expires*24*60*60*1000));
		let expDate = "expires="+ d.toUTCString()+";path=/";

		document.cookie = `${cookie}=${recipe}; ${expDate}`;
	},
	checkCookie: function(cookieName){
		cookieName = cookieName + '=';
		let cookieTin = decodeURIComponent(document.cookie);
		let cookies = cookieTin.split(';');
		for(let i = 0; i <cookies.length; i++) {
			let cookie = cookies[i];
			while (cookie.charAt(0) == ' ') {
				cookie = cookie.substring(1);
			}
			if (cookie.indexOf(cookieName) == 0) {
				return cookie.substring(cookieName.length, cookie.length);
			}
		}
		return '';
	},
	eatCookie: function(cookie){
		document.cookie = `${cookie}=; expires=Sun, 04 Jul 1971 00:00:00 UTC; path=/;`
	},
	// detect environment
	detectEnvironment: function(){
		var domain = window.location.hostname;

		for(var i=0; i < mzFunc.environments.length; i++){
			if(domain===mzFunc.environments[i][0]){
				return mzFunc.environments[i][1];
			}
		}
		mzFunc.logging('not found : mzFunc : environments');
	},
	//get ajax data
	doAJAXcall: function(tempURL, callback, sendType, beforeSend, outputData, isJson=true){
		//force type get
		if(sendType == undefined){
			sendType='POST';
		}
		var xhr = new XMLHttpRequest();
		xhr.onload = function () {
			// Process our return data
			if (xhr.status >= 200 && xhr.status < 300) {
				//We will strip any newline from our response.
				var TempResponse = xhr.response.replace(/(\r\n|\n|\r)/gm, "");
				// return the data
				if(isJson){
					callback(JSON.parse(TempResponse));
				}else{
					callback(TempResponse);
				}
			} else {
				// What do when the request fails
				var tempObj = new Object();
				tempObj.sucess = false;
				//you can change this error and add specific messaging in error.js
				tempObj.state = 'general';
				callback(tempObj);
			}
		};
		xhr.onerror = function(){
			var tempObj = new Object();
			tempObj.sucess = false;
			tempObj.state = 'general';
			callback(tempObj);
		};


		//send credentials
		if(beforeSend != undefined){
			xhr.withCredentials = false;
			xhr.open(sendType, tempURL, true);

			//loop through our beforeSend Array
			beforeSend.forEach(function(element){
				xhr.setRequestHeader(element[0], element[1]);
			});
		}else{
			xhr.open(sendType, tempURL);
			xhr.setRequestHeader("Accept", "application/json");
			xhr.setRequestHeader( 'Content-Type', 'application/x-www-form-urlencoded' );
		}
		if(outputData== undefined){
			xhr.send();
		}else{
			xhr.send(outputData);
		}
	},
	getDomPath: function(el) {
		if (!el) {
			return;
		}
		let stack = [];
		let isShadow = false;
		while (el.parentNode != null) {
			let sibCount = 0;
			let sibIndex = 0;
			// get sibling indexes
			for ( var i = 0; i < el.parentNode.childNodes.length; i++ ) {
				const sib = el.parentNode.childNodes[i];
				if ( sib.nodeName == el.nodeName ) {
					if ( sib === el ) {
						sibIndex = sibCount;
					}
					sibCount++;
				}
			}
			var nodeName = el.nodeName.toLowerCase();
			if (isShadow) {
				nodeName += "::shadow";
				isShadow = false;
			}
			if ( sibCount > 1 ) {
				stack.unshift(nodeName + ':nth-of-type(' + (sibIndex + 1) + ')');
			} else {
				stack.unshift(nodeName);
			}
			el = el.parentNode;
			if (el.nodeType === 11) { // for shadow dom, we
				isShadow = true;
				el = el.host;
			}
		}
		stack.splice(0,1); // removes the html element
		return stack.join(' > ');
	},
	getMediaQuery: function() {
		const breakpoints = {
			xs: 0,
			sm: 480,
			md: 767,
			lg: 1025,
			xl: 1200
		};

		let keys = Object.keys(breakpoints);
		let currentBP = null;

		for (let i = keys.length - 1; i >= 0; i--) {
			if (window.matchMedia(`(min-width: ${breakpoints[ keys[i] ]}px)`).matches) {
				currentBP = keys[i];
				break;
			}
		}

		return currentBP ;
	},
	loadJsSynchronously: function (scriptList, serverPath, i = 0, cacheBust, isFirstLoad) {
		if (i < scriptList.length) {
			let script = document.createElement('script');
			if(scriptList[i].includes('http')){
				script.setAttribute('src', scriptList[i] + "?v=" + cacheBust);
			}else{
				script.setAttribute('src', `${serverPath}${scriptList[i]}?v=${cacheBust}`);
			}
			
			script.async = false;
			script.addEventListener('load', ()=>{ mzFunc.logging('loaded js: ' + scriptList[i])});
			document.body.appendChild(script);
			// Once the file is loaded, it can recursively call this function to load the next script.

			if(scriptList.length - 1 === i && isFirstLoad){
				script.onload = this.init();
			}else if(scriptList.length-1 > i){
				this.loadJsSynchronously(scriptList, serverPath, i + 1, cacheBust, isFirstLoad);
			}
			
		}

	},
	loadCss: function(filename, cacheBust){
		const cssEl =  document.createElement('link');
		cssEl.rel  = 'stylesheet';
		cssEl.type = 'text/css';
		cssEl.href = filename + "?v=" + cacheBust;
		cssEl.media = 'all';
		document.body.appendChild(cssEl);
		cssEl.addEventListener('load', ()=>{ScrollTrigger.refresh(); mzFunc.logging('loaded css: ' + filename)});
	},
	logging: function(...args){
		if(mzFunc.loggingEnabled){
			console.log(args)
		}
	},
	matchHeight: function(elementClass) {
		var sortableList = document.querySelectorAll(elementClass);

		if(sortableList){
			var heights = [];

			for(var i = 0, x = sortableList.length; i < x; i++){
				if(sortableList[i].style && sortableList[i].style.height){
					sortableList[i].style.height = '';
				}
				heights.push(sortableList[i].clientHeight);
			};

			var max = Math.max.apply( Math, heights );

			for(var j = 0, y = sortableList.length; j < y; j++){
				sortableList[j].style.height = max + 'px';
			}
		};
	},
	pushToGTMDataLayer: function (data){
		mzFunc.logging('pushToGTMDataLayer', data);
	  try {
	    window.dataLayer.push(data);
	  } catch (err) {
	    mzFunc.logging('Error: dataLayer is not found in pushToGTMDataLayer().')
	  }
    },
	startScroller: function(){
		if(mzFunc.lastScrollheight != document.body.scrollHeight){
			ScrollTrigger.update();
			ScrollTrigger.refresh();
			mzFunc.lastScrollheight = document.body.scrollHeight
		}
		gsap.delayedCall(0.05, mzFunc.startScroller);
	},
	killScroller: function(isPaused){
		if(isPaused){
			document.body.classList.add('disabled');
		}else{
			document.body.classList.remove('disabled');
		}
	},
	triggerScrollHash: function(){
		// For newly opened link (e.g in new tab)
		const hash = window.location.hash;

		if (hash) {
			const target = document.getElementById(hash.substring(1));

			// HOTFIX FOR THE AR BLOCK NOT SCROLLING AT THE RIGHT PLACE
			if (hash.substring(1) === 'AR-MOBILE') {
				let calculatedOffset = mzFunc.offsetSubmenu+(screen.height / 2.8);

				if(/iPad|iPhone|iPod/.test(navigator.platform)) {
					calculatedOffset = mzFunc.offsetSubmenu-(screen.height / 3);
				}

				gsap.to(window, {duration: 2, scrollTo: {y: hash, offsetY: calculatedOffset, autoKill: true}});
			}

			if (target) {
				gsap.to(window, {duration: 2, scrollTo: {y: hash, offsetY: mzFunc.offsetSubmenu, autoKill: true}});
			}
		}

	},
	updateOffsets: function(isMenu){
		const alert = document.querySelector('.mz-alert:not(.mz-cookies, .mz-alert--permanent)');
		const permAlert = document.querySelector('.mz-alert--permanent');
		const menu = document.querySelector('.mz-menu');
		const submenu = document.querySelector('.mz-tabs-submenu');
		const stickySubmenu =  document.querySelector('.mz-sticky-submenu');
		const megaMenu = document.querySelector('.mz-megaMenu');
		const dropdown = document.querySelector('.mz-tabs-submenu .mz-tabs-menu-inner');
		const heroTitle =  document.querySelector('.mz-hero-menu .mz-hero-content');
		const pageTop =  document.querySelectorAll('.mz-page-top');
		const heroOuter =  document.querySelector('.mz-hero');
		const carouselHero = document.querySelector('.mz-carousel-hero');
		const reactAppForms = document.querySelector('.mzReactForms');
		const reactAppBnP = document.querySelector('.bnp > #root');

		const isFixedHeroOuter = heroOuter ? heroOuter.classList.contains('mz-hero-fixed') : false;

		let alertTop=0;
		if(alert){
			if(!alert.classList.contains('inactive') && !alert.classList.contains('mz-cookies')){
				alertTop = parseInt(alert.style.top, 10);
			}
		}
		let permAlertTop=0;
		if(permAlert){
			if(!['xs', 'sm'].includes(mzFunc.getMediaQuery())){
			  permAlert.style.top = mzFunc.offsetAlert + alertTop + 'px';
			  mzFunc.offsetPermAlert= permAlert.clientHeight;
			}
			permAlertTop = parseInt(permAlert.style.top, 10);
		}
		let menuTop = 0;
		if(menu) menuTop = parseInt(menu.style.top, 10);

		if(isMenu){
			if(dropdown){
				// Pinned submenu (see menu.js): value from scroll pin is already correct.
				// Do NOT recompute here — any recompute risks drift (offsetHeight /
				// permAlert mid-animation). Preserve existing inline top.
				if(submenu && submenu.classList.contains('is-pinned')){
					// intentionally empty
				}else{
				// Not pinned (page just loaded, near top): position fixed dropdown
				// from live geometry so the alert bar is counted exactly once.
				// Old formula added menuTop (= offsetAlert + offsetPermAlert) on top
				// of submenu.style.top which already contains those offsets —
				// hence double-counted offsetAlert whenever an alert bar exists.
				const submenuRect = submenu.getBoundingClientRect();
				const rightEl = submenu.querySelector('.mz-tabs--right');
				const rightH = rightEl ? rightEl.clientHeight : 0;
				if(['xs', 'sm'].includes(mzFunc.getMediaQuery())){
					if(rightEl) rightEl.style.top = (submenuRect.bottom + 1) + 'px';
					dropdown.style.top = (submenuRect.bottom + rightH + 1) + 'px';
				}else if(['md', 'lg'].includes(mzFunc.getMediaQuery())){
					dropdown.style.top = (submenuRect.bottom + 1) + 'px';
				}
				}
			}
		}else if(isMenu !='hero' && menu){
			document.querySelector('.mz-menu').style.top=(mzFunc.offsetAlert + mzFunc.offsetPermAlert) + 'px';
			if(submenu){
				submenu.style.top = ['xs', 'sm'].includes(mzFunc.getMediaQuery()) ? ((mzFunc.offsetAlert + mzFunc.offsetPermAlert + mzFunc.offsetMenu) - alertTop) + 'px' :
				((mzFunc.offsetAlert + mzFunc.offsetPermAlert + mzFunc.offsetMenu) - alertTop) + 'px';
			}
			if (stickySubmenu) {
				const height = stickySubmenu.offsetHeight;
				
				if (stickySubmenu.classList.contains('active')) {
					stickySubmenu.style.top = -height + 'px';
				}
			}

			if (reactAppForms) {
				reactAppForms.style.top = ['xs', 'sm'].includes(mzFunc.getMediaQuery()) ? 
					((mzFunc.offsetAlert + mzFunc.offsetPermAlert) - alertTop) + 'px' :
					((mzFunc.offsetAlert + mzFunc.offsetPermAlert) - alertTop - permAlertTop) + 'px';
			}

			if (reactAppBnP && permAlert) {
				const topValue = ['xs', 'sm'].includes(mzFunc.getMediaQuery()) ?
					((mzFunc.offsetAlert + mzFunc.offsetPermAlert) - alertTop) + 'px' :
					((mzFunc.offsetAlert + mzFunc.offsetPermAlert) - alertTop - permAlertTop) + 'px';

				reactAppBnP.style.top = topValue;
				// Fix issue in BnP summary page 
				reactAppBnP.style.marginBottom = topValue;
			}
			
			if(pageTop.length > 0){
				pageTop.forEach((elem) => {
					const marginTopValue = (mzFunc.offsetAlert + mzFunc.offsetPermAlert + mzFunc.offsetSubmenu);

					const innerStickySubmenu = elem.querySelector('.mz-sticky-submenu');

					if(innerStickySubmenu && !innerStickySubmenu.classList.contains('active')){
						elem.style.marginTop = '0px';
					} else {
						if(innerStickySubmenu && innerStickySubmenu.classList.contains('active')) {
							if (permAlert) {
								elem.style.marginTop = marginTopValue + 'px';
							} else {
								elem.style.marginTop = stickySubmenu.offsetHeight + marginTopValue + 'px';
							}
						}
						
					}

					// BNP
					if(document.querySelector('.BNP') && permAlert) {
						console.log('BNP found with permAlert, adding marginTopValue');
						elem.style.marginTop = marginTopValue + 'px';
					}
				});
			}
			
		}
		if(megaMenu){
			if(window.outerWidth >1024){
				megaMenu.querySelectorAll('.mz-megaMenu-item').forEach(menuItem =>{
					menuItem.style.paddingTop=((mzFunc.offsetAlert  + mzFunc.offsetPermAlert  + mzFunc.offsetMenu )- alertTop - permAlertTop) + 'px';
					if(menuItem.querySelector('.mz-tabs')){
						menuItem.querySelector('.mz-tabs').style.paddingTop = menuItem.style.paddingTop;
					}
					menuItem.querySelector('.mz-megaMenu-close').style.paddingTop = menuItem.style.paddingTop;
				});
			}else{
				megaMenu.style.top= ((mzFunc.offsetAlert  + mzFunc.offsetPermAlert  + mzFunc.offsetMenu)- alertTop) + 'px';
			}

		}
		if(carouselHero){
			const titlePadding = window.outerWidth > 768 ? 50 : 20;
			const carouselHeroArr =  carouselHero.querySelectorAll('.mz-hero-menu');
			const carouselHeroTitleArr =  carouselHero.querySelectorAll('.mz-hero-menu .mz-hero-content');
			carouselHeroArr.forEach((carouselHeroSlide )=>{
				if(alert || permAlert){
					carouselHeroSlide.style.marginTop = ['xs', 'sm'].includes(mzFunc.getMediaQuery()) ? mzFunc.offsetAlert + 'px':
						(mzFunc.offsetAlert + mzFunc.offsetPermAlert) + 'px';
					carouselHeroSlide.style.height = ['xs', 'sm'].includes(mzFunc.getMediaQuery()) ? 'calc(100% - ' + mzFunc.offsetAlert + 'px)' : 'calc(100% - ' +(mzFunc.offsetAlert + mzFunc.offsetPermAlert) + 'px)';
				}
			})
			carouselHeroTitleArr.forEach((carouselHeroTitle )=>{
				carouselHeroTitle.style.paddingTop = ((isFixedHeroOuter ? mzFunc.offsetAlert : 0) + (['xs', 'sm'].includes(mzFunc.getMediaQuery()) ? mzFunc.offsetPermAlert : 0) + mzFunc.offsetMenu + mzFunc.offsetSubmenu + mzFunc.offsetStickySubmenu + titlePadding) + 'px';
			})

		}else{
			if(heroTitle){
				const titlePadding = window.outerWidth > 768 ? 10 : 20;

				if (submenu) {
					heroTitle.style.paddingTop = ((isFixedHeroOuter ? mzFunc.offsetAlert : 0) + (['xs', 'sm'].includes(mzFunc.getMediaQuery()) ? mzFunc.offsetPermAlert : 0) + mzFunc.offsetMenu + /*mzFunc.offsetSubmenu +*/ mzFunc.offsetStickySubmenu + titlePadding) + 'px';
				}/* else {
					console.log(mzFunc.offsetPermAlert, mzFunc.offsetMenu, titlePadding);
					console.log(heroTitle.style.paddingTop);
					// HOTFIX before incentive Homepage case in mobile
					if(['xs', 'sm'].includes(mzFunc.getMediaQuery())) {
						heroTitle.style.paddingTop = ((alert ? mzFunc.offsetAlert : 0) + mzFunc.offsetMenu + titlePadding) + 'px';
					}
					console.log(heroTitle.style.paddingTop);

				}*/
				//heroTitle.style.paddingTop = ((isFixedHeroOuter ? mzFunc.offsetAlert : 0) + (['xs', 'sm'].includes(mzFunc.getMediaQuery()) ? mzFunc.offsetPermAlert : 0) + mzFunc.offsetMenu + /*mzFunc.offsetSubmenu +*/ mzFunc.offsetStickySubmenu + titlePadding) + 'px';
				//heroTitle.style.paddingTop = mzFunc.offsetMenu;
			}
			if(heroOuter){
				if(alert || permAlert){
					// PATCH FOR VIDEOWALL
					if(heroOuter.classList.contains('mz-videoWall')) {
						heroOuter.style.marginTop = ['xs', 'sm'].includes(mzFunc.getMediaQuery()) ? (mzFunc.offsetAlert + mzFunc.offsetPermAlert + menu.offsetHeight + submenu.offsetHeight) + 'px': 
							(mzFunc.offsetAlert + mzFunc.offsetPermAlert + menu.offsetHeight + submenu.offsetHeight) + 'px';

					} else {
						heroOuter.style.marginTop = ['xs', 'sm'].includes(mzFunc.getMediaQuery()) ? mzFunc.offsetAlert + 'px': 
							(mzFunc.offsetAlert + mzFunc.offsetPermAlert) + 'px';
					}

					if (!isFixedHeroOuter) {
						const currentHeight = heroOuter.outerHeight;
						heroOuter.style.height = ['xs', 'sm'].includes(mzFunc.getMediaQuery()) ? `calc(${currentHeight}px -  ${mzFunc.offsetAlert}px`:
						`calc(${currentHeight}px - ${mzFunc.offsetAlert + mzFunc.offsetPermAlert}px)`;
					}
				}
			}
		}
	},
	detectPhone: function(){
		var userAgent = navigator.userAgent || navigator.vendor || window.opera;
	
		// Windows Phone must come first because its UA also contains "Android"
		if (/windows phone/i.test(userAgent)) {
			return "Windows Phone";
		}
	
		if (/android/i.test(userAgent)) {
			return "Android";
		}
	
		// iOS detection from: http://stackoverflow.com/a/9039885/177710
		if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
			return "iOS";
		}
	
		return "unknown";
	},
	waitForEl: function(selector) {
		return new Promise(resolve => {
	        if (document.querySelectorAll(selector).length > 0) {
	            return resolve(document.querySelectorAll(selector));
	        }

	        const observer = new MutationObserver(mutations => {
	            if (document.querySelectorAll(selector).length > 0) {
	                resolve(document.querySelectorAll(selector));
	                observer.disconnect();
	            }
	        });

	        observer.observe(document.body, {
	            childList: true,
	            subtree: true
	        });
	    });
	},
	init: function(){
		if(mzFunc.detectEnvironment() === 'production'){
			mzFunc.vehicleListAPI = 'https://n8xgyscaa3.execute-api.ca-central-1.amazonaws.com/prod/api/Model/'
		} else if(mzFunc.detectEnvironment() === 'staging'){
			mzFunc.vehicleListAPI = 'https://8yispe2kgb.execute-api.ca-central-1.amazonaws.com/preprod/api/Model/'
		} else{
			mzFunc.vehicleListAPI = 'https://8yispe2kgb.execute-api.ca-central-1.amazonaws.com/preprod/api/Model/'
			//mzFunc.vehicleListAPI = 'https://890vi2xfz5.execute-api.ca-central-1.amazonaws.com/dev/api/Model/'
		}
		if (typeof mzMenu === 'object') {
			setTimeout(()=>{
				mzFunc.waitForEl('.mz-menu').then(function(){mzMenu.init();});
				mzFunc.waitForEl('.mz-tabs-submenu').then(function () { mzSubmenu.init(); });
				mzFunc.waitForEl('[animation-group]').then(function () { mzAnimator.init(); });
				mzFunc.waitForEl('.fileLoader').then(function(){mzFileLoader.init()});
				
				mzFunc.waitForEl('.mz-videoWall').then(function(){mzVideoWall.init();});

				mzFunc.startScroller();

				mzFunc.waitForEl('.mz-ar-block').then(function () { mzArBlock.init(); });
				mzFunc.waitForEl('.mz-card').then(function () { mzCard.init(); });
				mzFunc.waitForEl('.mz-tabs').then(function(components){mzTabs.init(components);});

				mzFunc.waitForEl('.mz-collapse:not(.mz-collapse-multi):not(.mz-collapse-forms)').then(function(components){	mzCollapseBlock.init(components); });
				mzFunc.waitForEl('.mz-360-container').then(function () { mz360Container.init(); });
				mzFunc.waitForEl('.mz-7030-image').then(function () { mz7030.init(); });
				mzFunc.waitForEl('.mzReactForms .mz-tabs').then(function(components){	mzTabs.init(components); });
				mzFunc.waitForEl('.mzReactForms .mz-table').then(function(components){	mzTable.init(components); });
				mzFunc.waitForEl('.mzReactForms .mz-collapse-forms').then(function(components){ mzCollapseBlock.init(components); });
				mzFunc.waitForEl('.mz-timeline').then(function () { mzTimeline.init(); });
				mzFunc.waitForEl('.mz-large-360').then(function (components) { mzLarge360.init(components) });
				mzFunc.waitForEl('.mz-large-360-interior').then(function (components) { mzLargeInterior360.init(components) });

				mzFunc.waitForEl('.lazy').then(function () {
					mzLazy.init();
					setTimeout(()=>{
						mzFunc.triggerScrollHash();
					},1000);
				});

				mzFunc.logging('waiting for the el');
			}, 250);
		}else{
			setTimeout(()=>{
				this.init();
			}, 250);
		}
	},
	initLoading: function(){
		mzFunc.logging('Init function');
		if(mzFunc.firstLoad){
			if(typeof window.serverPath === 'undefined'){
				window.serverPath = '/globalassets/static/';
			}
			const cacheBust = document.getElementById('firstjs') ?  
				document.getElementById('firstjs').src.split('v=')[1] !== undefined 
					?  document.getElementById('firstjs').src.split('v=')[1]
					: Math.floor(Math.random() * 1e16)
				:Math.floor(Math.random() * 1e16);

			const cssList =[
				'vendor/glide.core.min.css',
				'vendor/glide.theme.min.css',
				'https://cdn.jsdelivr.net/npm/@photo-sphere-viewer/core/index.min.css',
				'css/main.min.css',
			];
			
			// vendor js files need to be added before main.min.js.
			const scriptList = [
				'vendor/gsPlugins/SplitText.min.js',
				'vendor/gsPlugins/ScrollToPlugin.min.js',
				'vendor/gsPlugins/Draggable.min.js',
				'vendor/gsPlugins/InertiaPlugin.min.js',
				'vendor/glide.min.js',
				'vendor/papaparse.min.js',
				'https://cdn.jsdelivr.net/npm/three/build/three.min.js',
				'https://cdn.jsdelivr.net/npm/@photo-sphere-viewer/core/index.min.js',
				'js/main.min.js'
			];
	
			//load css after initial page load
			cssList.forEach((current, index, array) =>{
				if(current.includes('http')){
					mzFunc.loadCss(current, cacheBust);
				}else{
					mzFunc.loadCss(serverPath + current, cacheBust);
				}
				
			});
	
			// Synchronous Script Loading
			mzFunc.loadJsSynchronously(scriptList, serverPath, 0, cacheBust, true);
	
			//load images in mega menu (ScrollTrigger doesn't work here)
			const megaMenu = document.getElementById('megaMenu');
			if(megaMenu){
				const imageArr = megaMenu.getElementsByTagName('img');
				for(i=0; i < imageArr.length; i++){
					imageArr[i].src = imageArr[i].dataset.src;
				}
			}
			mzFunc.firstLoad=false;
		}
		mzFunc.loggingEnabled = this.detectEnvironment() === 'production' ? false : true;
	}
}
window.addEventListener("DOMContentLoaded", (event) => {
	mzFunc.logging('calling Init function');
	mzFunc.initLoading();
});